import ActionTypes from '../actions/actionTypes';

const initialState = {
  enrolmentStatusLoading: false,
  enrolmentStatusLoaded: false,
  enrolmentStatusError: false,
  enrolmentStatus: {},
  enrolmentStatusConnecting: false,

  myobLoginUriLoading: false,
  myobLoginUriLoaded: false,
  myobLoginUriError: false,
  myobLoginUri: '',
  myobDisconnectLoading: false,
  myobDisconnectLoaded: false,
  myobDisconnectError: false,

  xeroLoginUriLoading: false,
  xeroLoginUriLoaded: false,
  xeroLoginUriError: false,
  xeroLoginUri: '',
  xeroConnectLoading: false,
  xeroConnectLoaded: false,
  xeroConnectError: false,
  xeroDisconnectLoading: false,
  xeroDisconnectLoaded: false,
  xeroDisconnectError: false,
};

export function accountingIntegrationReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.REQUEST:
      return {
        ...state,
        enrolmentStatusLoading: true,
        enrolmentStatusLoaded: false,
        enrolmentStatusError: false,
        enrolmentStatus: {},
        enrolmentStatusConnecting: payload.isConnecting,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.SUCCESS:
      return {
        ...state,
        enrolmentStatusLoading: false,
        enrolmentStatusLoaded: true,
        enrolmentStatus: payload.enrolmentStatus,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.FAILURE:
      return {
        ...state,
        enrolmentStatusLoading: false,
        enrolmentStatusError: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.REQUEST:
      return {
        ...state,
        myobLoginUriLoading: true,
        myobLoginUriLoaded: false,
        myobLoginUriError: false,
        myobLoginUri: '',
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.SUCCESS:
      return {
        ...state,
        myobLoginUriLoading: false,
        myobLoginUriLoaded: true,
        myobLoginUri: payload.myobLoginUri,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.FAILURE:
      return {
        ...state,
        myobLoginUriLoading: false,
        myobLoginUriError: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.REQUEST:
      return {
        ...state,
        myobDisconnectLoading: true,
        myobDisconnectLoaded: false,
        myobDisconnectError: false,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.SUCCESS:
      return {
        ...state,
        myobDisconnectLoading: false,
        myobDisconnectLoaded: true,
        // Reset enrolmentStatus so connectionState.myobConnected immediately becomes false.
        // Without this, the "Disconnect" button stays visible until the next
        // getEnrolmentStatus poll because the new code derives connected state
        // from enrolmentStatus (not local state as the old code did).
        enrolmentStatus: {},
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.FAILURE:
      return {
        ...state,
        myobDisconnectLoading: false,
        myobDisconnectError: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.REQUEST:
      return {
        ...state,
        xeroLoginUriLoading: true,
        xeroLoginUriLoaded: false,
        xeroLoginUriError: false,
        xeroLoginUri: '',
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.SUCCESS:
      return {
        ...state,
        xeroLoginUriLoading: false,
        xeroLoginUriLoaded: true,
        xeroLoginUri: payload.xeroLoginUri,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.FAILURE:
      return {
        ...state,
        xeroLoginUriLoading: false,
        xeroLoginUriError: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.REQUEST:
      return {
        ...state,
        xeroConnectLoading: true,
        xeroConnectLoaded: false,
        xeroConnectError: false,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.SUCCESS:
      return {
        ...state,
        xeroConnectLoading: false,
        xeroConnectLoaded: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.FAILURE:
      return {
        ...state,
        xeroConnectLoading: false,
        xeroConnectError: true,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.REQUEST:
      return {
        ...state,
        xeroDisconnectLoading: true,
        xeroDisconnectLoaded: false,
        xeroDisconnectError: false,
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.SUCCESS:
      return {
        ...state,
        xeroDisconnectLoading: false,
        xeroDisconnectLoaded: true,
        // Same reason as MYOB_DISCONNECT.SUCCESS above.
        enrolmentStatus: {},
      };
    case ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.FAILURE:
      return {
        ...state,
        xeroDisconnectLoading: false,
        xeroDisconnectError: true,
      };
    default:
      return state;
  }
}
